import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

import { DrawingManagerContext } from '../context/drawing-manager-context.js';
import { ToolbarItem } from './toolbar-item.js';

import type { ElementType } from 'react';
import type { KeySequence } from 'react-hotkeys';
import type { DrawingManagerContextValue } from '../context/drawing-manager-context.js';
import type { IToolbarItem, IToolbarItemState } from './toolbar-item.js';

interface IOwnState extends IToolbarItemState {}

export class ToggleOrientationToolbarItem extends ToolbarItem<IOwnState> implements IToolbarItem {
	public static readonly ItemId = 'toggleorientation';
	id: string = ToggleOrientationToolbarItem.ItemId;
	title = 'Toggle toolbar orientation';
	iconElement: ElementType = SwapHorizIcon;
	defaultKeyBinding: KeySequence | undefined;
	keyEventName: string | undefined;
	includeInHistory = false;
	isExclusive = false;
	oneShot = true;
	// @ts-expect-error
	context: DrawingManagerContextValue | undefined;

	public onActiveStateChanged() {
		// Empty on purpose
	}

	public onKeyEvent(): void {
		// Empty on purpose
	}

	public onClick(): void {
		// Empty on purpose
	}
}

ToggleOrientationToolbarItem.contextType = DrawingManagerContext;
